/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_History_TooltipInputs */

const en_show_history_tooltip = /** @type {(inputs: Show_History_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show change history`)
};

const de_show_history_tooltip = /** @type {(inputs: Show_History_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsverlauf anzeigen`)
};

/**
* | output |
* | --- |
* | "Show change history" |
*
* @param {Show_History_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const show_history_tooltip = /** @type {((inputs?: Show_History_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_History_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_show_history_tooltip(inputs)
	return en_show_history_tooltip(inputs)
});